import * as React from 'react';

import {TabsHeaderProps} from './TabsHeader.type';
import {TabsHeaderList, TabHeaderItem} from './TabsHeader.style';

/**
 * TabsHeader Component
 * Displays tab navigation for workout routine form
 *
 * Migration Notes:
 * - Previously used WorkoutRoutineContext for errors
 * - Now accepts errors as a prop directly (optional)
 * - Requirements: 7.3 - Remove legacy context dependencies
 */
export const TabsHeader = (props: TabsHeaderProps): JSX.Element => {
  const {onPress, tabs, tabActive, errors = {}} = props;
  const [activeTab, setActiveTab] = React.useState('');

  const setTitleToTab = (tab) => {
    document.title = `${window.account}/admin - ${tab.label}`;
  };
  function checkTabActive() {
    const tabsActive = tabs.filter((tab) => tab.active === true);
    if (tabsActive.length) {
      setActiveTab(tabsActive[0].value);
      setTitleToTab(tabsActive[0]);
    } else {
      setActiveTab(tabs[0].value);
      setTitleToTab(tabs[0]);
    }
  }

  React.useEffect(() => {
    if (tabActive) setActiveTab(tabActive);
  }, [tabActive]);

  const onChangeTab = (tabValue) => {
    setActiveTab(tabValue);
    tabs.forEach((tab) => {
      const newTab = Object.assign({}, tab);
      if (newTab.value === tabValue) {
        newTab.active = true;
        setTitleToTab(newTab);
      } else {
        newTab.active = false;
      }
    });
    onPress(tabValue);
  };
  !activeTab && checkTabActive();
  return (
    <TabsHeaderList className="tabs-header-list">
      {tabs.map(({icon, label, value}, index) => (
        <TabHeaderItem
          key={index}
          onClick={() => onChangeTab(value)}
          active={activeTab === value}
          errors={
            (activeTab === 'edit' &&
              ((errors as any).target ||
                (errors as any).name ||
                (errors as any).startDate ||
                (errors as any).endDate) &&
              'errors') ||
            (activeTab !== 'edit' &&
              !!(errors as any).workoutGroups &&
              'errors')
          }
          className={`tab-header-item ${activeTab === value && 'active'}`}>
          {!!icon && (
            <span className="tab-header-icon">
              <i className={`fal fa-${icon}`}></i>&nbsp;
            </span>
          )}
          <span>{label}</span>
        </TabHeaderItem>
      ))}
    </TabsHeaderList>
  );
};
